<div class="navbar-container">
  <div class="container-fluid">
    <div class="logo-calypso">
      <img alt="logo-calypso" src="../../../assets/icons/header/calypso-logo-renew.svg" class="img"
        (click)="navigate('/')" />
    </div>
    <div class="row w-100 h-100 align-items-center">
      <div class="col-6">
        <div class="form-group">
          <div class="icon-in">
            <i class="fas fa-search"></i>
          </div>
          <input type="text" class="form-control" placeholder="Busca un producto..." id="searchProduct"
            [formControl]="search" (focus)="navigateCategory({ nombre: 'busqueda', slug: 'busqueda' })" />
        </div>
      </div>
      <div class="col-6 d-flex buttons-header">
        <div class="col-address d-flex align-items-center justify-content-center">
          <p class="address m-0" (click)="openAddressModal()" *ngIf="
                  activatedShippingMethod &&
                  activatedShippingMethod.type === 'Domicilio' &&
                  activatedShippingMethod.address
                ">
            <i class="fas fa-map-marker-alt"></i>
            {{ activatedShippingMethod.address?.nomenclatura }}
            {{ activatedShippingMethod.address?.numeroUno }} #{{ activatedShippingMethod.address?.numeroDos }}
            -
            {{ activatedShippingMethod.address?.numeroTres }} --
            {{activatedShippingMethod.address?.indicaciones}}
            <img src="../../../assets/icons/header/keyboard_arrow_down.svg" alt="flecha indicadora">
            <span *ngIf="coverage === 'NO'">Sin cobertura</span>
          </p>
          <p class="address m-0" (click)="openAddressModal()"
            *ngIf="activatedShippingMethod && activatedShippingMethod.type === 'Recogida'">
            <i class="fas fa-map-marker-alt"></i>
            <span *ngIf="!activatedShippingMethod.salePoint.distribuidor"> Recoger en:</span>
            {{activatedShippingMethod.salePoint.nombre}}
            <img src="../../../assets/icons/header/keyboard_arrow_down.svg" alt="flecha indicadora">
          </p>
          <p class="address m-0" (click)="openAddressModal()" *ngIf="
                  !activatedShippingMethod ||
                  (activatedShippingMethod.type === 'Domicilio' && !activatedShippingMethod.address)
                ">
            <i class="fas fa-map-marker-alt"></i>
            Método de entrega
            <img src="../../../assets/icons/header/keyboard_arrow_down.svg" alt="flecha indicadora">
          </p>
        </div>
        <div class="cart">
          <button type="button" class="btn btn-cart" (click)="onDeployShoppingCart()">
            <!-- <i class="fas fa-shopping-basket icon-button"></i> -->
            <img src="../../../assets/icons/header/shopping_cart.svg" alt="logo carrito">
            Carrito
            <div *ngIf="productsNumber > 0" class="number-products">
              {{ productsNumber }}
            </div>
          </button>
          <button type="button" class="btn btn-account" (click)="navigate('/login')">
            <i class="fas fa-user-alt icon-button"></i>
            Cuenta
          </button>
        </div>
      </div>
    </div>
  </div>

</div>
